import {combineReducers} from 'redux';

import comments from './org-comments/reducer';
import details from './org-details/reducer';
import edit from './org-edit/reducer';

export default combineReducers({details, edit, comments});
